import { render, staticRenderFns } from "./BaseDataList.vue?vue&type=template&id=44f2eaa2&"
import script from "./BaseDataList.vue?vue&type=script&lang=js&"
export * from "./BaseDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports